import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const KEY = 'gm:selectedBusinessId';

/**
 * Single source of truth for the active client: the `:id` route param under
 * `/client/:id/*`. Mirrors the id into localStorage so non-client routes and
 * old-URL redirects have a sensible fallback. Returns null when not inside a
 * client workspace.
 */
export function useSelectedBusinessId(): string | null {
  const { id } = useParams<{ id: string }>();
  useEffect(() => {
    if (id) localStorage.setItem(KEY, id);
  }, [id]);
  return id ?? null;
}

/** Last-used client id (fallback for redirects outside a client workspace). */
export function getStoredBusinessId(): string | null {
  return localStorage.getItem(KEY);
}
